import { Box, Skeleton } from '@inflearn/ds-react-next';

export default function RoadmapSkeletonItem({ count }: { count?: number }) {
  if (count) {
    return (
      <>
        {Array.from({ length: count })
          .fill(1)
          .map((_, i) => (
            <Box w="100%" key={i}>
              <Skeleton w="100%" h={130} radius="sm" />
              <Box px={4} pb={4} mt={12}>
                <Skeleton w={220} h={24} radius="sm" maw="100%" />
              </Box>
            </Box>
          ))}
      </>
    );
  }

  return (
    <Box w="100%">
      <Skeleton w="100%" h={130} radius="sm" />
      <Box px={4} pb={4} mt={12}>
        <Skeleton w={220} h={24} radius="sm" maw="100%" />
      </Box>
    </Box>
  );
}
